import { AxiosError } from "axios";

import { api } from "@/lib/axios";

type Material = {
	id: string;
	material_id: string;
	title: string;
	format: "image" | "document" | "text" | "link";
	available: boolean;
	link: string;
	created_at: string;
};

export type Lesson = {
	id: string;
	name: string;
	description: string;
	position: number;
	available: boolean;
	mentor: {
		id: string;
		name: string;
		image: string;
	};
	link: string;
	module: string;
	module_id: string;
	duration: number;
	timeWatched: number;
	watched: boolean;
	materials: Material[];
	created_at: string;
};

export async function showLesson(id: string): Promise<
	| {
			status: "success";
			data: Lesson;
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get(`/lesson/show/${id}`);

		return {
			status: "success",
			data: data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
